import { useInView } from "react-intersection-observer";

const cards = [
	{
		icon: "📉",
		title: "Potensi Zakat & Wakaf Belum Optimal",
		desc: "Potensi zakat Indonesia mencapai Rp327 triliun/tahun namun pengelolaan lembaga belum terintegrasi dan transparan.",
	},
	{
		icon: "🏗️",
		title: "Lembaga Butuh Ekosistem Lengkap",
		desc: "Masjid, pesantren, dan LAZ membutuhkan ekosistem digital, ekonomi, dan spiritual yang terintegrasi dalam satu program.",
	},
	{
		icon: "🌐",
		title: "Transformasi Digital Keislaman",
		desc: "Era digital menuntut lembaga keislaman hadir secara digital — pengelolaan keuangan, data jamaah, dan ZISWAF berbasis teknologi.",
	},
	{
		icon: "🌱",
		title: "Kemandirian Ekonomi Umat",
		desc: "Lembaga keislaman harus mampu menciptakan sumber pendapatan mandiri untuk keberlanjutan dakwah dan program sosial.",
	},
];

function WCard({ card, delay }) {
	const { ref, inView } = useInView({ threshold: 0.1, triggerOnce: true });
	return (
		<div
			ref={ref}
			style={{
				...styles.card,
				opacity: inView ? 1 : 0,
				transform: inView ? "translateY(0)" : "translateY(28px)",
				transition: `opacity 0.6s ${delay}s, transform 0.6s ${delay}s`,
			}}
			onMouseEnter={(e) => {
				e.currentTarget.style.transform = "translateY(-4px)";
				e.currentTarget.style.boxShadow = "0 14px 36px rgba(123,63,0,.1)";
				e.currentTarget.style.borderColor = "var(--kuning)";
			}}
			onMouseLeave={(e) => {
				e.currentTarget.style.transform = "translateY(0)";
				e.currentTarget.style.boxShadow = "none";
				e.currentTarget.style.borderColor = "rgba(123,63,0,.1)";
			}}>
			<div style={styles.icon}>{card.icon}</div>
			<div>
				<h3 style={styles.title}>{card.title}</h3>
				<p style={styles.desc}>{card.desc}</p>
			</div>
		</div>
	);
}

export default function LatarBelakang() {
	const { ref: headRef, inView: headIn } = useInView({
		threshold: 0.1,
		triggerOnce: true,
	});

	return (
		<section id="latar" style={styles.section}>
			<div style={styles.pattern} />
			<div
				ref={headRef}
				style={{
					...styles.head,
					opacity: headIn ? 1 : 0,
					transform: headIn ? "translateY(0)" : "translateY(20px)",
					transition: "all 0.6s",
				}}>
				<div style={styles.lbl}>
					<span style={styles.lblText}>Latar Belakang</span>
				</div>
				<h2 style={styles.h2}>Mengapa MASQUDE Hadir?</h2>
				<p style={styles.sub}>
					Lembaga keislaman Indonesia memiliki potensi luar biasa — MASQUDE
					hadir untuk memaksimalkan potensi tersebut melalui program
					pemberdayaan yang terstruktur dan berkelanjutan
				</p>
			</div>

			<div className="grid-why" style={styles.grid}>
				{cards.map((c, i) => (
					<WCard key={c.title} card={c} delay={i * 0.12} />
				))}
			</div>
		</section>
	);
}

const styles = {
	section: {
		background: "var(--krem2)",
		padding: "6rem 5%",
		position: "relative",
		overflow: "hidden",
	},
	pattern: {
		position: "absolute",
		inset: 0,
		backgroundImage:
			"radial-gradient(circle, rgba(123,63,0,.06) 1px, transparent 1px)",
		backgroundSize: "30px 30px",
		pointerEvents: "none",
	},
	head: {
		textAlign: "center",
		marginBottom: "3rem",
		position: "relative",
		zIndex: 1,
	},
	lbl: { marginBottom: "0.8rem" },
	lblText: {
		display: "inline-block",
		background: "var(--coklat)",
		color: "var(--kuning2)",
		padding: "0.28rem 0.95rem",
		borderRadius: "2rem",
		fontSize: "0.72rem",
		fontWeight: 800,
		letterSpacing: "3px",
		textTransform: "uppercase",
	},
	h2: {
		fontFamily: "Lora, serif",
		fontSize: "clamp(1.7rem, 3.5vw, 2.7rem)",
		fontWeight: 700,
		color: "var(--coklat)",
		marginBottom: "0.8rem",
	},
	sub: {
		color: "var(--abu)",
		fontSize: "0.97rem",
		maxWidth: "600px",
		margin: "0 auto",
		lineHeight: 1.7,
	},
	grid: {
		gap: "1.4rem",
		maxWidth: "900px",
		margin: "0 auto",
		position: "relative",
		zIndex: 1,
	},
	card: {
		background: "white",
		borderRadius: "14px",
		padding: "1.8rem",
		border: "1.5px solid rgba(123,63,0,.1)",
		display: "flex",
		gap: "1.1rem",
		transition: "all 0.3s",
		cursor: "default",
	},
	icon: {
		width: "46px",
		height: "46px",
		minWidth: "46px",
		background: "linear-gradient(135deg, #FFF0CC, #FFE08A)",
		borderRadius: "12px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		fontSize: "1.4rem",
	},
	title: {
		fontSize: "0.97rem",
		fontWeight: 700,
		color: "var(--coklat)",
		marginBottom: "0.35rem",
	},
	desc: { fontSize: "0.86rem", color: "var(--abu)", lineHeight: 1.65 },
};
